import { AuthService } from '../services/auth.service';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

export function initializeAuth(authService: AuthService, platformId: Object) {
  return async () => {
    // Only run in browser
    if (!isPlatformBrowser(platformId)) {
      return;
    }

    try {
      const token = authService.getToken();
      
      if (!token) {
        console.log('No token found, skipping auth initialization');
        return;
      }

      // Check if token is expired
      if (await authService.isTokenExpired()) {
        
        try {
          const newTokenData = await authService.getNewToken();
          authService.saveToken(newTokenData);
        } catch (error) {
          console.error('Token refresh failed during initialization:', error);
          authService.logout();
          return;
        }
      }

      // Load user data
      try {
        const userData = await authService.getUserData();
        authService.saveUserData(userData);
      } catch (error) {
        console.error('Failed to load user data:', error);
        // Don't logout here, let the interceptor handle it
      }
    } catch (error) {
      console.error('Error during auth initialization:', error);
    }
  };
}
